export interface FitRecordedMetric { key: string; name: string; unit: string; source: string; count: number; min: number | null; avg: number | null; max: number | null; average_source?: 'samples' | 'device'; }
export interface FitRecordedMetadata { version: string; profile: string; metrics: FitRecordedMetric[]; fields: Record<string, { name: string; message: string; count: number; known: boolean; classification: string }>; }
export const FIT_METRIC_FA: Record<string,string> = {
  "distance": "مسافت",
  "altitude": "ارتفاع",
  "heart_rate": "ضربان قلب",
  "temperature": "دمای حسگر",
  "respiration_rate": "نرخ تنفس",
  "power": "توان",
  "accumulated_power": "شمارندهٔ توان تجمعی",
  "cadence": "آهنگ رکاب",
  "left_pco": "انحراف محل اعمال نیرو از مرکز پدال چپ",
  "right_pco": "انحراف محل اعمال نیرو از مرکز پدال راست",
  "speed": "سرعت",
  "total_elapsed_time": "زمان سپری‌شده",
  "total_timer_time": "زمان فعال تایمر",
  "total_distance": "مسافت ثبت‌شدهٔ دستگاه",
  "total_cycles": "تعداد رکاب",
  "total_work": "کار مکانیکی ثبت‌شده",
  "time_standing": "زمان رکاب‌زدن ایستاده",
  "power_position": "توان برحسب وضعیت بدن",
  "training_load_peak": "بار تمرین ثبت‌شدهٔ گارمین",
  "total_calories": "انرژی مصرف‌شدهٔ دستگاه",
  "total_ascent": "صعود ثبت‌شده",
  "total_descent": "نزول ثبت‌شده",
  "normalized_power": "توان نرمال‌شدهٔ دستگاه",
  "training_stress_score": "بار تمرین ثبت‌شدهٔ دستگاه",
  "intensity_factor": "ضریب شدت ثبت‌شدهٔ دستگاه",
  "threshold_power": "توان آستانهٔ ثبت‌شده",
  "front_gear_shift_count": "تعداد تعویض دندهٔ طبق",
  "rear_gear_shift_count": "تعداد تعویض دندهٔ خودرو",
  "stand_count": "تعداد دفعات رکاب‌زدن ایستاده",
  "vam": "سرعت صعود عمودی",
  "metabolic_calories": "انرژی متابولیک ثبت‌شده",
  "total_training_effect": "اثر تمرین هوازی گارمین",
  "cadence_position": "آهنگ رکاب برحسب وضعیت بدن",
  "total_anaerobic_training_effect": "اثر تمرین بی‌هوازی گارمین",
  "total_grit": "شاخص دشواری مسیر (Grit)",
  "grit": "شاخص دشواری مسیر (Grit)",
  "flow": "شاخص روانی حرکت (Flow)",
  "jump_count": "تعداد پرش‌ها",
  "left_torque_effectiveness": "اثربخشی گشتاور پای چپ",
  "right_torque_effectiveness": "اثربخشی گشتاور پای راست",
  "left_pedal_smoothness": "یکنواختی رکاب‌زدن پای چپ",
  "right_pedal_smoothness": "یکنواختی رکاب‌زدن پای راست",
  "power_balance_left": "سهم توان پای چپ",
  "power_balance_right": "سهم توان پای راست",
  "left_right_balance": "تعادل توان چپ و راست",
  "calories": "انرژی ثبت‌شده",
  "battery_soc": "شارژ باتری دستگاه",
  "gps_accuracy": "دقت موقعیت‌یابی",
  "grade": "شیب",
  "time_in_hr_zone": "زمان در ناحیه‌های ضربان قلب",
  "neg_grade": "شیب سرازیری",
  "pos_grade": "شیب سربالایی",
  "combined_pedal_smoothness": "یکنواختی ترکیبی رکاب‌زدن",
  "total_fat_calories": "انرژی حاصل از چربی، ثبت دستگاه",
  "total_moving_time": "زمان در حال حرکت",
  "time_in_cadence_zone": "زمان در ناحیه‌های آهنگ رکاب",
  "time_in_power_zone": "زمان در ناحیه‌های توان",
  "pos_vertical_speed": "سرعت عمودی صعود",
  "neg_vertical_speed": "سرعت عمودی نزول",
  "grade_adjusted_speed": "سرعت تعدیل‌شده با شیب",
  "vertical_oscillation": "نوسان عمودی",
  "ground_contact_time": "زمان تماس با زمین",
  "vertical_ratio": "نسبت عمودی",
  "step_length": "طول گام ثبت‌شده",
  "cycle_length16": "طول چرخهٔ حرکت، ثبت دستگاه",
  "workout_feel": "احساس تمرین ثبت‌شدهٔ گارمین",
  "workout_rpe": "ادراک فشار ثبت‌شدهٔ گارمین، مقدار فایل",
  "active_time": "زمان فعالیت",
  "stress": "شاخص استرس ثبت‌شده",
  "num_lengths": "تعداد طول‌های شناشده",
  "stroke_distance": "مسافت طی‌شده در هر حرکت شنا",
  "pool_length": "طول استخر",
  "num_active_lengths": "تعداد طول‌های فعال شنا",
  "strokes_per_length": "تعداد حرکات شنا در هر طول",
  "swolf": "شاخص سواُلف (SWOLF)",
  "surface_interval": "زمان استراحت در سطح آب",
  "depth": "عمق",
  "vertical_speed": "سرعت عمودی",
  "cycles": "شمارندهٔ چرخه‌های حرکت",
  "stance_time_percent": "درصد زمان تماس با زمین",
  "ground_contact_balance": "تعادل زمان تماس با زمین، پای چپ",
  "core_temperature": "دمای مرکزی بدنِ حسگر",
  "skin_temperature": "دمای پوستِ حسگر",
  "core_data_quality": "کیفیت دادهٔ حسگر دمای مرکزی",
  "core_reserved": "فیلد رزرو حسگر CORE",
  "heat_strain_index": "شاخص تنش گرمایی",
  "est_power": "توان تخمینیِ حسگر",
  "ascent": "صعود تجمعیِ حسگر",
  "descent": "نزول تجمعیِ حسگر",
  "vo2": "مصرف اکسیژن ثبت‌شدهٔ حسگر",
  "energy": "نرخ مصرف انرژیِ حسگر",
  "ftp_power": "توان آستانهٔ ثبت‌شدهٔ حسگر",
  "ftp_time": "مدت آستانهٔ ثبت‌شدهٔ حسگر",
  "np_power": "توان نرمال‌شدهٔ حسگر",
  "vo2_max": "بیشینهٔ مصرف اکسیژن ثبت‌شدهٔ حسگر",
  "ant_hr": "ضربان قلب حسگر ANT+",
  "c_power": "توان اختصاصی حسگر (C Power)",
  "a_power": "توان اختصاصی حسگر (A Power)",
  "pedal_power_balance": "تعادل توان پدالِ حسگر",
  "charge": "شارژ حسگر",
  "left_power_phase": "فاز اعمال نیرو، پای چپ",
  "left_power_phase_start": "زاویهٔ آغاز فاز اعمال نیرو، پای چپ",
  "left_power_phase_end": "زاویهٔ پایان فاز اعمال نیرو، پای چپ",
  "left_power_phase_peak": "فاز اوج اعمال نیرو، پای چپ",
  "left_power_phase_peak_start": "زاویهٔ آغاز فاز اوج اعمال نیرو، پای چپ",
  "left_power_phase_peak_end": "زاویهٔ پایان فاز اوج اعمال نیرو، پای چپ",
  "right_power_phase": "فاز اعمال نیرو، پای راست",
  "right_power_phase_start": "زاویهٔ آغاز فاز اعمال نیرو، پای راست",
  "right_power_phase_end": "زاویهٔ پایان فاز اعمال نیرو، پای راست",
  "right_power_phase_peak": "فاز اوج اعمال نیرو، پای راست",
  "right_power_phase_peak_start": "زاویهٔ آغاز فاز اوج اعمال نیرو، پای راست",
  "right_power_phase_peak_end": "زاویهٔ پایان فاز اوج اعمال نیرو، پای راست"
};
const FIT_UNITS_FA: Record<string,string> = {
  "m": "متر",
  "mm": "میلی‌متر",
  "cm": "سانتی‌متر",
  "m/s": "متر/ثانیه",
  "meters/hr": "متر/ساعت",
  "watts": "وات",
  "w": "وات",
  "kcal": "کیلوکالری",
  "kcals/min": "کیلوکالری/دقیقه",
  "j": "ژول",
  "bpm": "ضربه/دقیقه",
  "rpm": "دور/دقیقه",
  "breaths/min": "نفس/دقیقه",
  "c": "درجهٔ سانتی‌گراد",
  "°c": "درجهٔ سانتی‌گراد",
  "°": "درجه",
  "degrees": "درجه",
  "percent": "٪",
  "%": "٪",
  "ms": "میلی‌ثانیه",
  "s": "ثانیه",
  "minutes": "دقیقه",
  "cycles": "چرخه",
  "lengths": "طول",
  "strokes/length": "حرکت/طول",
  "strokes / length": "حرکت/طول",
  "ml/min/kg": "میلی‌لیتر/کیلوگرم/دقیقه",
  "ml/min": "میلی‌لیتر/دقیقه",
  "a.u.": "واحد قراردادی",
  "if": "",
  "tss": "",
  "flow": "",
  "kgrit": "",
  "q": "واحد کیفیت حسگر"
};
export function normalizeFitMetricName(name: string): string {
 return name.replace(/\u00c2(?=[\u00ae\u00b0])/g,'').replace(/[\u202a-\u202e\u2066-\u2069]/g,'').toLowerCase().replace(/^ciq_/, '').replace(/[ ®.+-]+/g,'_').replace(/_+/g,'_').replace(/^lap_/,'').replace(/^(avg|min|max)_/,'').replace(/_$/,'');
}
export function fitMetricLabel(name: string, persian: boolean): string {
 const normalized=normalizeFitMetricName(name);
 if (persian && /^ciq_/i.test(name)) return `${fitMetricLabel(name.slice(4),true)} · کانکت آی‌کیو`;
 if (!persian) return name.replace(/_/g,' ');
 const component=normalized.match(/^(.*)_component_(\d+)$/);
 if (component) return `${fitMetricLabel(component[1],true)} · مؤلفهٔ ${component[2]}`;
 const peak=normalized.match(/^powerpeak_?(\d+)(s|m)$/);
 if (peak) return `اوج توان ثبت‌شده · ${peak[1]} ${peak[2]==='s'?'ثانیه':'دقیقه'}`;
 return FIT_METRIC_FA[normalized] ?? `شاخص اختصاصی دستگاه (${name.replace(/[\u202a-\u202e\u2066-\u2069]/g,'')})`;
}
export function fitMetricUnit(metric: FitRecordedMetric, persian: boolean): string {
 const unit=metric.unit.replace(/\u00c2(?=[\u00ae\u00b0])/g,'');
 if (metric.name.includes('training_effect')) return persian?'از ۵':'of 5';
 if (unit==='°' && metric.name.toLowerCase().includes('temperature')) return persian?'درجهٔ سانتی‌گراد':'°C';
 return persian ? FIT_UNITS_FA[unit.toLowerCase()] ?? unit : unit;
}
export function fitMetricGroup(metric: FitRecordedMetric): string {
 const name=normalizeFitMetricName(metric.name);
 if (/reserved|data_quality|battery|gps_accuracy|accumulated_power|^cycles$|total_cycles|workout_rpe|workout_feel/.test(name)) return 'technical';
 if (/pedal|torque|power_phase|pco|standing|stand_count|gear_shift|power_position|cadence_position|power_balance/.test(name)) return 'cycling';
 if (/stroke|swolf|pool|lengths|surface_interval|depth/.test(name)) return 'swimming';
 if (/step_length|ground_contact|stance_time|vertical_oscillation|vertical_ratio|cycle_length/.test(name)) return 'running';
 if (/temperature|heat|respiration|training_effect|training_load|vo2|stress/.test(name)) return 'physiology';
 if (/altitude|grade|ascent|descent|vertical_speed|vam|grit|flow|jump/.test(name)) return 'terrain';
 return 'other';
}
// These are already shown in the core summary; their recorded fields remain inventoried.
export function visibleFitMetric(metric: FitRecordedMetric): boolean {
 if (normalizeFitMetricName(metric.name) === 'accumulated_power') return false;
 if (/reserved/i.test(metric.name)) return false;
 if (![metric.min,metric.avg,metric.max].some(v=>typeof v==='number' && Number.isFinite(v))) return false;
 return !new Set(['distance','total_distance','total_timer_time','heart_rate','power','cadence','speed','normalized_power','training_stress_score','intensity_factor','calories','total_calories','total_ascent','total_descent','threshold_power','total_elapsed_time','total_work','vam']).has(metric.name);
}
